//@ts-check

import React, { Suspense } from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "@material-ui/styles"
import { createMuiTheme } from "@material-ui/core/styles"
import theme from "../theme"
import CssBaseline from "@material-ui/core/CssBaseline"

const localTheme = {
  ...theme,
  typography: {
    ...theme.typography,
    fontFamily: "EYInterstate",
  },
}

const StyleWrapper = ({ children }) => (
  <ThemeProvider theme={createMuiTheme(localTheme)}>
    <CssBaseline />
    {children}
  </ThemeProvider>
)

StyleWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.node,
  ]).isRequired,
}

export default StyleWrapper
